// Model.js
// -----------------------
// @module Case
define("BluePoint.VerifyEmail.VerifyEmail.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/VerifyEmail/SuiteScript2/VerifyEmail.Service.ss"
            ),
            true
        )
    });
});
